<template>
	<div id="app" class="app" :class="theme">
		<hyper-cloud-console-vue v-if="variablesReady"
			:customui="!isCustomJournal && onPublicPage"
			:class="{'invisible': !isAuthenticated}"
			ref="console"
		/>
		<navigation v-if="!loading" />
		<router-view v-if="!loading" />
		<spinner v-else />
		<error-dialog ref="errorDialog" />
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Navigation from './components/core/Navigation';
import Spinner from './components/shared/Spinner';
import ErrorDialog from './components/shared/ErrorDialog';
import ThemeService from './services/theme';
import Journal from './services/journal';
import HyperCloudConsoleVue from './components/core/HyperCloudConsoleVue';
import {
	enable as enableDarkMode,
	disable as disableDarkMode,
	setFetchMethod,
} from 'darkreader';

export default {
	name: 'App',
	components: {
		Navigation,
		ErrorDialog,
		Spinner,
		HyperCloudConsoleVue,
	},
	data() {
		return {
			theme: 'light',
			loading: true,
			onPublicPage: true,
			variablesReady: false
		};
	},
	//Here I prefetch data that the app will need upon loading.
	created() {
	
		Journal.instance()
			.matchJournal()
			.then(() => {
				document.title = Journal.instance().journalTitle();
				
				this.fetchIndexArticles();
				this.fetchArticleTypes();
				
				this.variablesReady = true;
			});
	
		this.$store.state.consoleReady$.promise.then(() => {
			this.loading = false;
		});
		
		this.listenForThemeChanges();
		
	},
	methods: {
		...mapActions([
			'fetchIndexArticles',
			'fetchArticleTypes'
		]),
		listenForThemeChanges: function () {
			ThemeService.instance().events.on('themechanged', () => {
				this.theme = ThemeService.instance().getTheme();
				if (this.theme == 'dark') {
					setFetchMethod(window.fetch);
					enableDarkMode({
						brightness: 100,
						contrast: 90,
						sepia: 10,
					});
				} else {
					disableDarkMode();
				}
			});
		},
	},
	//Computed prop will re-evaluate every time the error field in the
	//store changes.
	computed: {
		...mapGetters(['isAuthenticated']),
		storeError: function() {
			return this.$store.state.error;
		},
		isCustomJournal: function() {
			return Journal.instance().journalCode();
		}
	},
	//We are handling the change of the error in a watcher - in this
	//case we are showing a modal. Why here? Computed props are
	//best suited for pure value transformations, watchers are better
	//for logic implementation.
	watch: {
		$route(to) {
			this.onPublicPage = to.meta.access === 'PUBLIC';
		},
		storeError() {
			if (this.storeError) {
				this.$refs.errorDialog.show(this.storeError);
			}
		},
	},
};
</script>

<style>
@import '~bootstrap/dist/css/bootstrap.css';
@import '~bootstrap-vue/dist/bootstrap-vue.css';
@import '~hyper-bootstrap/bootstrap-override.css';
@import './styles/variables.css';
@import './styles/layout.css';
@import './styles/editor.css';

.add-article {
	position: fixed;
	right: 25px;
	bottom: 25px;
	width: 50px;
	aspect-ratio: 1/1;
	background-image: url('./assets/icons/blue-plus.svg');
	background-repeat: no-repeat;
	background-position: center;
	background-color: transparent;
	border: 1.5px solid var(--textAdmin);
	border-radius: 50%;
}
.add-article:focus {
	outline: none;
}
.add-article:hover {
	background-color: var(--textAdminHover);
}
.router-link-exact-active {
	border-top: none;
	color: var(--textPrimary);
}
.hl {
	background-color: #f7e8cd;
}
.modal-xl {
	width: 90vw;
}
.modal-xl .modal-content {
	width: 100%;
	height: 100%;
}
@media (min-width: 1200px) {
	.modal-xl {
		max-width: 90vw;
	}
}
</style>
